module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a27"
    }
  }), _vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Mom, can I go swimming in the river?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“The river! You’ll be swept away, and I’ll never see you again!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“What’s holding up the line, Keith?” Boudreaux’s Big Buy assistant manager Greg Dooley ran a tight ship.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Nofing, Greg. Evwy thing’s,” sniffle, “good.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Greg liked to inspect the troops at least every fifteen minutes, literally looking over his checkers’ shoulders sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I was telling this fine young man he should be home in bed,” Dusty said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Greg backed up. “Why aren’t you?” he asked Keith-Aaron.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You taid I hab to—”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Finish with Mr. Whitehead and then leave early!” A metal travel mug of coffee in one hand, Greg used the other to roll up a copy of that week’s Boudreaux’s sale circular. “That’s an order.” He swatted at Keith-Aaron as if scolding a puppy.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The little man who acted like a big one had shouted a different order just a couple hours earlier, Keith-Aaron recalled.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’b not sure I should cob in today, Gweg.” Breathing only through his mouth during a phone call forty minutes before his shift was to start, he had pled his case for a sick day. “I’b pwetty congested, and I don’t wamba get anyone elth sick. Maybe I sood stay hobe.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Greg’s response was ripe with concern for his customers and Boudreaux’s employee of close to thirteen years. “Your ass will be behind that register, or it’ll be on the unemployment line.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I cab harbly breave!”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You don’t have to smell the groceries, just scan them.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Hours later, now, it seemed, Greg was having a change of heart—if he had a heart—at least in front of Dusty and the rest of the store’s clientele.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You, um, need to take care of yourself, Keith.” Perhaps, he was afraid Dusty might turn him into a snail or a skunk. “Rest up and come back when you’re better.” Greg grabbed Dusty’s reusable grocery bag right from Keith-Aaron’s grip. “That’s an order.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Wielding such power was exciting judging by the stiffness of Greg’s nipples nearly poking through his red Boudreaux’s Big Buy polo shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“And, ya know, gesundheit.” He stuffed Dusty’s candy into the bag, “I’ll put Brenda on register,” then snatched his change and passed it over.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Sowwy.” Keith-Arron handed back Dusty’s store card. “Hab a nithe day. Dere’s hamb samitizer at the end of the counder.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Thank you, Keith-Aaron. I hope you have a nice day, too. And apologies are not necessary.” Enchanted by mystical bayou water or not, Dusty was a kind man. “Get well soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yeah. Get well and all that.” Greg’s shove felt more sincere than his words. “Go! I’ll count out your register before passing it over to Brenda.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("If Keith-Aaron claimed he didn’t feel a tinge of satisfaction witnessing Greg dribble coffee down the entire front of his shirt with a single guzzle from his giant travel mug, it would be a lie.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Son of a b—” Greg apparently remembered where he was before finishing the curse word.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I wish I could drive you home.” Dusty Whitehead wore a devious grin, and there was definitely a glint in his eyes when Keith-Aaron’s met them. “But I have an appointment.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("At least half the people watching would claim Dusty made the coffee spill happen.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“It’s okay,” Keith-Aaron told him. “Going to de doccor keeps you wib us wonger.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The devious smile broadened. “Or so everyone thinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’ll call Marc.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Do you need a ride?” One of Lee-Marie’s dads was shopping that day.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The other gawkers gawking would attribute Greg’s so-called accident to the woman at his side, his mother, Lee-Marie’s "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Granmè, ")]), _vm._v("Livienne Chandelier.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("She was a petite woman, short but somewhat broad. Her whole body undulated when she walked. The fabric that covered her, usually traditional to her Creole culture, often a solid color with ruffles at the shoulders and hem, would twist and gyrate around her with each step, like clothes being agitated in a washing machine. While Lee-Marie wore her tignon only occasionally these days, Livienne was never seen without one. Keith-Aaron’s mother had learned of the headwrap while diligently studying southern hair culture as a beautician back in Georgia in the late 1980s. Upon her arrival in Eerie Falls in 2003, Fayette walked into the salon then owned by Livienne hoping to acquire a second job with that knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Livienne and Fayette had a lack of height in common. Other than that, they were near complete opposites. Keith-Aaron’s mother was blond and small all over—except her voice. Livienne Chandelier spoke not a word. Keith-Aaron and his mother soon learned the woman communicated just fine in other ways, often with a slap at Fayette’s wrist followed by a gentle touch guiding her hands while teaching her how to do Black hair. Within the first year, Livienne left the shop to retire. Shortly thereafter, the salon once simply called Livienne’s, was relaunched as Fabulous Fayette’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Keith-Aaron spent nearly every afternoon with the Chandelier family after school during his first few years in Eerie Falls. Lee-Marie’s two fathers were intriguing. Seeing one come from the kitchen to kiss and cuddle the other when he got home from work made feelings that developed in Keith-Aaron later not so scary, because it had already made yet another kind of family just every day and ordinary.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Communication within the household was uncanny. Lee-Marie and Keith-Aaron would be watching cartoons. Without a single word spoken, or even a gesture like Livienne would use with others, Lee-Marie got up from the floor one day, went to the kitchen, and filled a glass with sweet tea for her granmè.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“How did you know what she wanted?” Keith-Aaron asked in a whisper.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Lee-Marie shrugged. “We just do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The men, too, Livienne’s son, Lee, and son-in-law, Ansel, would just rise from the sofa and head to the kitchen or upstairs as if their name had been called. A conversation would follow, words going only one way, but somehow two-sided.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Even after so many years, Keith-Aaron never got the hang of that, but he knew Livienne adored him through her actions. Papa Lee informed Keith-Aaron one day Livienne wanted him to call her ")]), _vm._v("Granmè"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(", just like Lee-Marie did, instead of ma’am or Ms. Chandelier. Livienne loved to feed him. Of all the things she made, Gateau l’Orange was Keith-Aaron’s favorite. Every year for his birthday, he had two cakes, one his mother bought, and one Livienne made.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This afternoon in the store, Livienne mimed steering a car. “"), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Let us take you home,")]), _vm._v("” Keith-Aaron imagined her saying.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“No, no, "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Granmè")]), _vm._v(". Marc dopped me off. He’ll cob an get me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Livienne might have scowled.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“But tank you.” Keith-Aaron cleared his throat and nasal passages with a cough and a sniff. “Thank you for the offer.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Let us know if you can’t get hold of him.” Papa Lee added his two cents, his voice and doubt loud and clear.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“He’ll be dere.” Keith-Aaron dug down into his pocket for his phone as he rushed toward the "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Employees Only ")]), _vm._v("door rather than defend Marc’s character any further from implied slings and arrows.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The employee "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("lounge ")]), _vm._v("was little bigger than a closet. White concrete walls and an acoustic ceiling, the only difference between it and a prison cell were a soda machine and a couple of green plastic lawn chairs. Suddenly lightheaded and weak in the knees, Keith-Aaron collapsed into one. Smirking seemed to make his nose run more, so he put the image of Greg and his coffee out of mind and tapped Marc’s face on the phone screen.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Shid.” It went right to voicemail, so Keith-Aaron hung up and opted for a text instead.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Keith-Aaron: Come get me? I’m too sick to work.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Quickly chilled to the bone, Keith-Aaron wished Dusty could wave a magic wand like Glinda the Good Witch to instantly put him in his toasty warm bed. There was no place like home. Since Keith-Aaron’s sneakers were red, since he’d been drinking the same water as Dusty for years now and hanging around alleged voodoo priestess Livienne Chandelier, he tried clicking them together after closing his eyes in case some of their magical abilities had rubbed off on him.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Thanksgiving dinner, summer barbecues, birthday celebrations, two Easter Sundays so far and one just around the corner, as an adult, Keith-Aaron spent more time at Whitehead Manor than he did with the Chandeliers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“There used to be so many more of us,” Dusty seemed to say at every gathering.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("His word was all Keith-Aaron had to go on. The assemblage was always small since he’d joined the fold, often no more than three—Dusty, Marc, and Keith-Aaron. On one rare occasion, Marc’s mother and father had come. Dusty’s granddaughter, Portia, had married a Montclair way up in Connecticut, Timothy Montclair. Portia’s father, Dusty’s son, Buck, had already passed on, along with several Whitehead siblings. When Gerald visited, it was usually on his own during school vacations, such as spring break, which he was on now.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Keith-Aaron recalled all the times he watched TV with Dusty. He remembered opening Christmas gifts side by side with the man. They had even shared several All Hallows’ Eves, both starting and ending at the witching hour, if the witching hour was just after midnight. Keith-Aaron wasn’t sure, the internet was divided, and Dusty’s take was, “Whenever the spirits are stirred, they show themselves and work their ways.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Dusty Whitehead’s 250 year-old home and funeral parlor did have the air of a haunted mansion at times, due to age and untamed forestation on the outside that created a lack of sunlight indoors. Dusty swore sometimes he even heard rumblings from another realm there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“The older I get, the closer to becoming a spirit myself, it feels as if these mystical voices come with greater ease,” he’d recently said through a melancholy mood, the words spoken in front of one of his late wife Sharon’s favorite plants in the yard. “I wish for someone, and they might just whisper. I feel them. Though always with a twist.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Were those conversations throughout the years more of Dusty playing to his character, or was it something he truly believed? All Keith-Aaron knew for certain as he sat in the stuffy employees’ lounge was he’d never been witness to blatant sorcery beyond the show he’d sat on gym bleachers to watch as a boy. Relaxing homegrown herbal teas, mushrooms from the woods that might temporarily alter the mind, wild flora plucked and rolled into cigarettes that did something similar, those were things Dusty had shared. Incantations and spells, if he conjured and performed those, he kept that all to himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Returning from past memories for a check of the phone for an incoming text in the present proved fruitless.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Keith-Aaron: You coming, Marc?")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("So, after sending another message of his own, Keith-Aaron embarked on a rather lengthy, rather sweet memory.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Dusty’s oldest great-grandson, Marc, had powers for sure. Marc’s charm was intoxicating. It was magical. He’d caught Keith-Aaron’s attention and, truth be told, his heart right off the bat. The fact he held an actual bat of the sporting variety while doing so was merely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("It was almost three years earlier, October, 2020. Fresh off the field after a softball game, Marc had sauntered into Boudreaux’s Big Buy on a hot autumnal evening that should have been cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Porterhouse steak…” Keith-Aaron chatted up the stranger as he would any customer he knew by name. “Asparagus, a delectable cabernet, and cheesecake…” He took note of every item while scanning them for the handsomest one to ever show up in his line.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Tight baseball pants streaked with grass met the top of powder blue socks with dark blue stripes at the elastic circling muscular calves. An untucked tank top that showed off impressive shoulders, biceps, and slightly tanner forearms lightly pelted in golden fur was still fresh and white. His New Milford Marlins cap indicated he was an out of towner. From another state, in fact. It was turned backwards, and a sweaty glow to his stubbled cheeks came with goosebumps all up and down those beautiful arms from the high-powered AC. Both the cheeks and the arms required a second look.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“You always eat so well after a game?” The first thing Keith-Aaron had noticed, even before all that, was the unusual combination of curly blond hair and soulful brown eyes. “Or is today special somehow?” This time, his chatting bordered on flirting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Maybe.” The athletic stranger had a sexy smile, too. It was imperfect in a way. Kind of crooked. One side of his mouth turned up higher and opened fuller than the other, revealing a pointy tooth—a canine tooth—on one side. If it had a match on the other, canine bookends to two perfectly straight, square, white teeth on top, Keith-Aaron didn’t see it at first. To him, what some might call a flaw made the guy more adorable. “First date,” he told Keith-Aaron. “Hoping to impress someone I’d like to see more of.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Ah.” Lucky woman, Keith-Aaron thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“So, it’s good? The menu, I mean? All food you’d go for?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Two other customers had joined the line behind the baseball stud by now.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Honestly?” Keith-Aaron scanned the cheesecake a second time, since the bloop he wanted came out as a buzz. “I’m not a fan.” He held it up. “Chocolate’s more my thing. For me, cheese is for macaroni and ham sandwiches.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Ha!” The baller laughed. “In that case…” Then he was on the move, headed for the aisles again. “Be right back,” he called over one shoulder with just a hint of sunburnt red.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Take your time.” So utterly charismatic, apparently to both genders, Mrs. Vale, next in line, didn’t seem to mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The bakery aisle was a straight run, and the runner, still carrying the baseball bat for some reason, made it a quick one. He left Lee-Marie smiling. From her lips, all the way to the elastic on the hairnet that smooshed her natural afro into submission, every part of her beautiful ebony face was in on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("A round chocolate cake under a plastic dome, a box of cider doughnuts, and a brown paper bag with something from the display case Lee-Marie had gotten for him, somehow, the unfamiliar cutie managed it all with just the one free hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“The very helpful woman back there said you’re a freak for pumpkin muffins.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Yes.” Keith-Aaron knew immediately from the delicious aroma. “The season trigger a desire for you, too?” he asked as he ran the desserts through the price scanner.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Something other than the season did.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Huh?” When Keith-Aaron went to bag the items, he found his hand captured in one a bit larger.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“The doughnuts and muffin are for you,” the guy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“No.” Keith-Aaron felt his cheeks getting warm. “You don’t have to—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I want to, Keith-Aaron.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Yeah, but…”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I really, ")]), _vm._v("really"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" want to, Keith-Aaron.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I’m Marc, by the way. With a C.” Marc took back his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I’m…”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Keith-Aaron.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Yes.” It was fortunate Marc knew, because Keith-Aaron was drawing a blank. “You said it twice before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Because I read it right there on your chest a while ago.” Marc touched the nametag and then let his finger wander left to a spot over Keith-Aaron’s heart. “The first time I came in here with my great-grandfather. How come you have two names?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I always wondered that myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("For a moment, Keith-Aaron had forgotten Mrs. Vale was there. He’d forgotten where he was. “Umm…My grampa and father are also Keiths. We’re not junior and the third, though. Different middle names. With three of us, it just became easier for relatives to add those. Especially my mother, so Dad and I would know which one of us she was yelling at. ")]), _vm._v("Keith-Walter! Keith-Aaron!"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" Mostly, it was Dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Marc’s crooked smile was even sexier close up, as he leaned across the conveyor belt and laid his bat atop it. “Cool.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Deodorant and a mild whiff of cologne were pleasant, but they didn’t totally mask the enticing aroma of man funk. The smell of sweat from hard play rivaled pumpkin spice as far as Keith-Aaron was concerned. It got him all revved up. An aromatic trace of celebratory beer added to it, and he wanted to explore every scent some more, from Marc’s mouth to all the places on his body perspiration made damp. “Did you win?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Seven, zip,” Marc said. “Their favor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("So, the beer was conciliatory.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Right now, I couldn’t care less about baseball scores, Keith-Aaron.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The cash register pinged and hummed, bringing Keith-Aaron back to reality. Back to work. “Automatic—involuntary—I didn’t even know I’d hit the buttons to finish the purchase.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Automatic and involuntary…” Marc licked his lips, and Keith-Aaron wondered how salty they were. “I get it.” He also noticed, once Marc took out his wallet to pay, the bulge it made wasn’t the biggest one in his baseball pants.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Fifty-four eighteen. Do you have a Boudreaux’s Big Bucks Buyers’ Bonanza discount card.” Keith-Aaron’s lip twitched, possibly also involuntarily. “I was supposed to ask that first.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I don’t.” Marc handed over three twenties. “I’ll get one. ‘Cause this is now my favorite place to shop. You got a pen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Yeah.” Keith-Aaron handed it over and wondered why someone not paying by check wanted a pen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“My receipt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("He gave that to Marc, too, after making change.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“If it wouldn’t hold up the line, I’d fill out the application for the card right now.” Marc scribbled on the back of the register tape. “But here are my digits and address another way. You got dinner plans, Keith-Aaron?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“When?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Uh-uh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“What time do you get off?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Six.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Seven-thirty, then?” Marc handed over the information and the pen. “Big house on River Road.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Mr. Whitehead’s?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Yeah. I’m staying at Great-grampa Dusty’s a while.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Nice!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“So, I’ll see you then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Sounds good.” Keith-Aaron’s heart was beating fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Looks like I won today, after all. See you tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("There was nothing fancy about the exterior of Dusty Whitehead’s abode. No columns or ornate architecture was evident in the dark of night barely affected by the yellow glow of one bulb near a side door up high. The house was a big, basic rectangle with a dozen square windows in front, pretty much like houses built before the start of the twentieth century in rural parts of the south were. The horizontal gray siding might once have been smooth but now was marked with bumps, scratches, and peeling paint.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I’m making a little apartment up over Great-grampa’s garage.” Marc was down at the base of the driveway when Keith-Aaron pulled in just a couple hours after their very first meeting at the store. An I’m on the way phone call had alerted him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I’ve never seen the place up close in the dark,” Keith-Aaron said. “No one I know well enough to attend their funeral has died yet.” He cursed his conversation skills. “Not down here, anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“So, you weren’t born in Eerie Falls?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("They spoke while climbing a long, steep staircase up the side of the old house toward the yellow light.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I was pretty young when we came, though, after my parents’ divorce. Is Eerie Falls home to you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“For barely a week now,” Marc said. “But I like it. I grew up in Connecticut. My grandparents couldn’t wait to get out of here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("There were a lot of steps. Keith-Aaron was breathing hard just halfway up. Breathing hard and sweating. October of 2020 was a scorcher.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“My mom and dad were never too keen on visiting. They all say it’s haunted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The legend went back a long time, apparently.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Is it?” Keith-Aaron asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Marc shrugged. “Some odd stuff happens now and then. If Great-gramma’s here, I hope she’ll say hi someday. Careful. The railing’s a bit loose in spots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Oh.” Keith-Aaron stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“I’ll hold on to you.” Marc literally did, wrapping one arm around Keith-Aaron’s waist from behind. “Just to make sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Marc Montclair was better at sweet talk and chivalry than he was with pots and pans. The steak he’d prepared down in his great-grandfather’s kitchen was under seasoned and over-seared, the asparagus slimy and limp. Fortunately, within ten minutes after the last bite, Marc wasn’t limp at all, as he quickly proved his sexual prowess went the way of his charm and not his cooking. To say his bedroom skills improved on those in the kitchen would have been false, however, since the apartment didn’t yet have separate rooms, and the sex started right on the table where they’d eaten.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Do we have to be quiet?” With his pants and underwear at his ankles and his shirt next to the meat platter, Keith-Aaron felt the cold of a butter knife and maybe some butter on his bare back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("“Nah. We’re over the mortuary section, not the living quarters. Unless we make enough noise to wake the dead, we’re good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("From October 2020, back to March 2023, “You were pretty quick to come that night,” Keith-Aaron muttered as he checked his phone while still waiting in the employees’ lounge for Marc. “Where the heck are you now?” The equally pressing question was, “Do I really want to know?”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df5c14c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0